module.exports={select:"选择",selected:"已选择"};